import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { LiveChat } from './components/LiveChat';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Product } from './pages/Product';
import { HelpMeChoose } from './pages/HelpMeChoose';
import { AboutPage } from './pages/AboutPage';
import { DeliveryZones } from './pages/DeliveryZones';
import { Subcontractors } from './pages/Subcontractors';
import { DiyHelp } from './pages/DiyHelp';
import { ContractorOrdering } from './pages/ContractorOrdering';
import { CartProvider } from './components/CartContext';
import { CartDrawer } from './components/CartDrawer';
import { AnnouncementBar } from './components/AnnouncementBar';
function ScrollToHash() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      // Small delay to let the page render before scrolling
      setTimeout(() => {
        const el = document.getElementById(location.hash.replace('#', ''));
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);
  return null;
}
export function App() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved) {
      return saved === 'dark';
    }
    return true;
  });
  useEffect(() => {
    localStorage.setItem('theme', isDark ? 'dark' : 'light');
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark]);
  const toggleDark = () => setIsDark(!isDark);
  return <Router data-id="element-0">
      <CartProvider data-id="element-1">
        <div className={`min-h-screen flex flex-col font-sans ${isDark ? 'dark' : ''}`} data-id="element-2">
          <div className="flex-grow bg-[#fdfbf7] dark:bg-[#222222] transition-colors duration-300 pb-16 md:pb-0" data-id="element-3">
            <ScrollToHash data-id="element-4" />
            <AnnouncementBar data-id="element-5" />
            <Navbar isDark={isDark} toggleDark={toggleDark} data-id="element-6" />
            <Routes data-id="element-7">
              <Route path="/" element={<Home data-id="element-9" />} data-id="element-8" />
              <Route path="/contact" element={<Contact data-id="element-11" />} data-id="element-10" />
              <Route path="/shop/:slug" element={<Product data-id="element-13" />} data-id="element-12" />
              <Route path="/help" element={<HelpMeChoose data-id="element-15" />} data-id="element-14" />
              <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
              <Route path="/delivery-zones" element={<DeliveryZones data-id="element-19" />} data-id="element-18" />
              <Route path="/subcontractors" element={<Subcontractors data-id="element-21" />} data-id="element-20" />
              <Route path="/contractor-ordering" element={<Subcontractors data-id="element-23" />} data-id="element-22" />
              <Route path="/diy-help" element={<DiyHelp data-id="element-25" />} data-id="element-24" />
            </Routes>
            <Footer data-id="element-26" />
            <LiveChat data-id="element-27" />
            <StickyMobileCTA data-id="element-28" />
            <CartDrawer data-id="element-29" />
          </div>
        </div>
      </CartProvider>
    </Router>;
}